import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { UpdateAppConfigValueInput } from './UpdateAppConfigValueInput';
import { UpdateAppConfigValueOutput } from './UpdateAppConfigValueOutput';

export class UpdateAppConfigValueService extends HttpServiceBase {

  handle = (input: UpdateAppConfigValueInput): Promise<Result<UpdateAppConfigValueOutput> | null> => {
    const promise = this.http.put<Result<UpdateAppConfigValueOutput>, UpdateAppConfigValueInput>(`${this.baseUrlSislogApi}/v2/app-config/${input.id}/new-value`, input);
    return promise;
  }
}